export default "__VITE_ASSET__BzYi3go9__"